import React from "react";

function OurAssetTok() {
  return (
    <div className="home-blog-area default-padding">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h4 className="sub-title">Latest Blog</h4>
              <h2 className="title split-text-right split-text-in-right">
                Our Asset Tokenization Services
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <div className="blog-style-one fade-up-anim">
              <div className="thumb zoom-thumb">
                <img
                  className="img-reveal"
                  src="https://validthemes.net/site-template/robok/assets/img/blog/1.jpg"
                  alt="Thumb"
                />
              </div>
              <div className="info">
                <a>
                  <h2 className="blog-title">Real Estate Tokenization</h2>
                </a>
                <p>
                  Unlock property liquidity by tokenizing real estate assets,
                  enabling fractional ownership and 24/7 trading opportunities
                  for investors.
                </p>
              </div>
            </div>

            <div className="blog-style-one fade-up-anim">
              <div className="thumb zoom-thumb">
                <img
                  className="img-reveal"
                  src="https://validthemes.net/site-template/robok/assets/img/blog/2.jpg"
                  alt="Thumb"
                />
              </div>
              <div className="info">
                <a>
                  <h2 className="blog-title">Commodities Tokenization</h2>
                </a>
                <p>
                  Tokenize precious metals, energy commodities, and other
                  tangible assets to enable secure, global trading and efficient
                  ownership transfer.
                </p>
              </div>
            </div>

            <div className="blog-style-one fade-up-anim">
              <div className="thumb zoom-thumb">
                <img
                  className="img-reveal"
                  src="https://validthemes.net/site-template/robok/assets/img/blog/3.jpg"
                  alt="Thumb"
                />
              </div>
              <div className="info">
                <a>
                  <h2 className="blog-title">
                    Intellectual Property Tokenization
                  </h2>
                </a>
                <p>
                  Make intellectual property rights accessible and divisible,
                  allowing creators and investors to monetize IP securely.
                </p>
              </div>
            </div>
            <div className="blog-style-one fade-up-anim">
              <div className="thumb zoom-thumb">
                <img
                  className="img-reveal"
                  src="https://validthemes.net/site-template/robok/assets/img/blog/5.jpg"
                  alt="Thumb"
                />
              </div>
              <div className="info">
                <a>
                  <h2 className="blog-title">Collectibles and Fine Art</h2>
                </a>
                <p>
                  Make high-value art and collectibles investment-ready by
                  transforming ownership into digital tokens, bringing
                  transparency and fractional ownership.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurAssetTok;
